<ng-container *transloco="let t">
  <div class="flex flex-auto leading-none text-xs font-medium tracking-tight opacity-70"
       [class.justify-center]="align === 'center'" [class.justify-end]="align === 'end'">
    <div class="flex gap-1 truncate">
      @if(searchService.startIndex() > 0) {
      <span>{{ searchService.startIndex() | number: '1.0' }}</span>
      <span>-</span>
      <span>{{ searchService.endIndex() | number: '1.0' }}</span>
      <span>{{ t('of') }}</span>
      }
      <span>{{ searchService.count() | number: '1.0' }}</span>
      @if(searchService.selectedCount() > 0) {
      <span>-</span>
      <span>{{ searchService.selectedCount() }} x</span>
      }


    </div>
  </div>
</ng-container>
